import React from 'react';
import MainLayout from '../../layout/MainLayout';
import ContactDetails from './ContactDetails';
import ContactFrom from './ContactFrom';

const Contact = () => {
    return (
        <MainLayout>
            <h2><span className='text-blue-500'>C</span>ontact Me</h2>
            <hr />
            <ContactDetails />
            <br />
            <ContactFrom />
        </MainLayout>
    );
};

export default Contact;